import { useTranslation } from "react-i18next";
import { Link } from "@tanstack/react-router";
import { SunDim } from "lucide-react";
import { buttonVariants } from "@/components/ui/button";
import { getRedirectPath } from "@/lib/utils";

export function HasNoPermissionPage() {
  const { t } = useTranslation();

  // Safely get redirect path with fallback
  let redirectTo = "/login";
  try {
    redirectTo = getRedirectPath();
  } catch (error) {
    console.warn("Failed to get redirect path:", error);
    redirectTo = "/login";
  }

  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-4">
      <div className="flex flex-col items-center justify-center gap-4 p-4 lg:max-w-96">
        <Link to={redirectTo}>
          <SunDim className="h-12 w-12 text-primary" />
        </Link>
        <h1 className="text-4xl font-bold">{t("403 Forbidden")}</h1>
        <p className="text-balance text-center">
          {t(
            "Sorry, you are not allowed to access this resource. If you believe this is an error, please contact our support team to get access.",
          )}
        </p>
        <Link to={redirectTo} className={buttonVariants({ className: "w-full" })}>
          {t("Return to dashboard")}
        </Link>
      </div>
    </div>
  );
}
